import { useState } from "react";
import { Search, Trophy } from "lucide-react";
import { SportsBoard } from "@/components/predict/SportsBoard";
import { MarketSheet } from "@/components/predict/MarketSheet";
import { PicksStrip } from "@/components/predict/PicksStrip";

export default function Sports() {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-5" data-testid="sports-page">
      <section className="relative overflow-hidden rounded-2xl border border-[var(--line)] p-5 sm:p-7"
        style={{ backgroundImage: "linear-gradient(90deg, rgba(7,9,14,.96) 35%, rgba(7,9,14,.55)), url(https://images.unsplash.com/photo-1569531955323-33c6b2dca44b?auto=format&fit=crop&w=1400&q=60)", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="flex items-center gap-2 text-[11px] font-bold uppercase tracking-[.18em] text-[var(--sports)]"><Trophy className="w-4 h-4" />Sportsbook</div>
        <h1 className="font-head font-extrabold text-4xl sm:text-5xl mt-2">Live Sports Odds</h1>
        <p className="text-sm text-slate-300 mt-2 max-w-lg">Every game on Polymarket US: winners, spreads, totals and futures. Prices are the crowd's chance in cents. Tap any line to practice a bet or ask the AI.</p>
        <label className="mt-4 flex items-center gap-2 h-12 rounded-xl bg-[var(--bg)]/80 border border-[var(--line)] px-3 max-w-md focus-within:border-[var(--cyan)]">
          <Search className="w-4 h-4 text-slate-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search a team, player or league" className="flex-1 bg-transparent outline-none text-sm" data-testid="sports-search-input" />
        </label>
      </section>
      <PicksStrip category="sports" onOpen={setOpen} />
      <SportsBoard q={q} onOpen={setOpen} />
      <MarketSheet slug={open} onClose={() => setOpen(null)} />
    </div>
  );
}
